import TarjetasBloqueadas from "../../services/administrar/tarjetas_bloqueadas.js";
import { Refresh } from "../../services/refreshToken.js";
import dayjs from "dayjs";

export default {
  namespaced: true,
  state: {
    tarjetasBloqueadas: [],
    rowsPerPage: 10,
    page: 1,
    total: 0,
    visible: 7,
    errored: false,
    error: false,
    cargando: false,
    documento: null,
    email: null,
    todos: false,
    fechaInicio: dayjs()
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
    fechaFin: dayjs().format("YYYY-MM-DD"),
  },
  mutations: {
    setTarjetasBloqueadas(state, tarjetasBloqueadas) {
     state.tarjetasBloqueadas = tarjetasBloqueadas;
    },
    setFechaInicio(state, value) {
      state.fechaInicio = value;
    },

    setFechaFin(state, value) {
      state.fechaFin = value;
    },
    setDocumento(state, value) {
      state.documento = value;
    },

    setEmail(state, value) {
      state.email = value;
    },

    setTodos(state, value) {
      state.todos = value;
    },

    setCargando(state, value) {
      state.cargando = value;
    },
    setPaginate(state, value) {
        state.page = value;
      },
    setrowsPerPage(state, value) {
      state.rowsPerPage = value;
    },
    setErrord(state, value) {
      state.errored = value;
    },
    setTotal(state, value) {
      state.total = value;
    },
  },
  actions: {

    setFechaInicio({ commit }, fecha) {
      commit("setFechaInicio", fecha);
    },

    setFechaFin({ commit }, fecha) {
      commit("setFechaFin", fecha);
    },

    setDocumento({ commit }, documento) {
      commit("setDocumento", documento);
    },

    setEmail({ commit }, email) {
      commit("setEmail", email);
    },

    setTodos({ commit }, todos) {
      commit("setTodos", todos);
    },

    async getTarjetasBloqueadas({ commit, state }) {
      try {
        const params = {
          Number: state.page,
          Size: state.rowsPerPage,
          // FechaInicio: state.fechaInicio,
          // FechaFin: state.fechaFin,
        };
        params.DocumentoAsociado = state.documento
        params.EmailAsociado = state.email
        params.Todos = state.todos;

        commit("setCargando", true);
        const response = await TarjetasBloqueadas.getTarjetasBloqueadas(params);
        if (response?.data?.tarjetas == null) {
          commit("setTarjetasBloqueadas", []);
          commit("setTotal", 0);
        } else {
          commit("setTarjetasBloqueadas", response?.data?.tarjetas);
          commit("setTotal", response?.data?.meta?.page?.lastPage);
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          try {
            await Refresh.getRefreshToken();
            return await dispatch("getTarjetasBloqueadas");
          } catch (refreshError) {
            // console.error("Error al obtener el token de refresco:", refreshError);
          }
        } else {
          commit("setErrord", true);
        }
      } finally {
        commit("setCargando", false);
      }
    },

    async bloquearDesbloquearTarjeta({ dispatch }, payload) {
      try {
        const body = {
          Id: payload.Id,
          Desbloquear: payload.Desbloquear,
          Permanente: payload.Permanente,
        }
        const response = await TarjetasBloqueadas.postBloqDesbloqTarjeta(body);
        await dispatch("getTarjetasBloqueadas");
        return response;
      } catch (error) {
        if (error.response && error.response.status === 403) {
          try {
            await Refresh.getRefreshToken();
            return await dispatch("bloquearDesbloquearTarjeta", payload);
          } catch (refreshError) {
            // console.error("Error al obtener el token de refresco:", refreshError);
          }
        } else {
          // Manejo de otros errores si es necesario
        }
      }
    },

    
  },
  getters: {
    tarjetasBloqueadas: (state) => state.tarjetasBloqueadas,
    page: (state) => state.page,
    rowsPerPage: (state) => state.rowsPerPage,
    total: (state) => state.total,
    cargando: (state) => state.cargando,
    documento: (state) => state.documento,
    email: (state) => state.email,
    fechaInicio: (state) => state.fechaInicio,
    fechaFin: (state) => state.fechaFin,
    todos: (state) => state.todos,
  },
  modules: {},
};
